// extracted by mini-css-extract-plugin
module.exports = {"leaderboard":"Leaderboard_leaderboard__2aqRJ","leaderboardAd":"Leaderboard_leaderboardAd__3FQPh","video":"Leaderboard_video__1-YeT"};